import { useEffect, useRef, useState } from "react";

export function useMatchSocket(matchId) {
  const [state, setState] = useState(null);
  const [event, setEvent] = useState(null);
  const wsRef = useRef(null);

  useEffect(() => {
    if (!matchId) return;
    const backend = process.env.REACT_APP_BACKEND_URL;
    const url = backend.replace(/^http/, "ws") + `/api/ws/match/${matchId}`;
    let alive = true;
    let reconnectTimer = null;
    const connect = () => {
      if (!alive) return;
      const ws = new WebSocket(url);
      wsRef.current = ws;
      ws.onmessage = (e) => {
        try {
          const msg = JSON.parse(e.data);
          if (msg.type === "state") setState(msg.match);
          if (msg.type === "event") setEvent({ ...msg, t: Date.now() });
        } catch (_) { /* ignore */ }
      };
      ws.onclose = () => {
        if (alive) reconnectTimer = setTimeout(connect, 1500);
      };
      ws.onerror = () => { try { ws.close(); } catch (_) { /* ignore */ } };
    };
    connect();
    return () => {
      alive = false;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      try { wsRef.current?.close(); } catch (_) { /* ignore */ }
    };
  }, [matchId]);

  return { state, event };
}
